import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

// Lazy-loaded pages for code splitting
const HomePage = lazy(() => import("@/pages/HomePage"));
const BonusesPage = lazy(() => import("@/pages/BonusesPage"));
const BrandsPage = lazy(() => import("@/pages/BrandsPage"));
const BrandDetailPage = lazy(() => import("@/pages/BrandDetailPage"));
const BonusClusterPage = lazy(() => import("@/pages/BonusClusterPage"));
const ComparisonsPage = lazy(() => import("@/pages/ComparisonsPage"));
const ComparisonSEOPage = lazy(() => import("@/pages/ComparisonSEOPage"));
const GuidesPage = lazy(() => import("@/pages/GuidesPage"));
const GuideDetailPage = lazy(() => import("@/pages/GuideDetailPage"));
const BonusRulesPage = lazy(() => import("@/pages/BonusRulesPage"));
const BonusRuleDetailPage = lazy(() => import("@/pages/BonusRuleDetailPage"));
const HubPage = lazy(() => import("@/pages/HubPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));

function PageLoader() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="animate-pulse space-y-6">
        <div className="h-8 w-1/3 rounded-lg bg-muted" />
        <div className="h-4 w-2/3 rounded bg-muted" />
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-48 rounded-xl bg-muted" />
          ))}
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Navbar />
        <main className="min-h-[calc(100vh-4rem)]">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {/* Core pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/bonuses" element={<BonusesPage />} />
              <Route path="/bonuses/:type" element={<BonusesPage />} />
              <Route path="/brands" element={<BrandsPage />} />
              <Route path="/brands/:slug" element={<BrandDetailPage />} />
              <Route path="/comparisons" element={<ComparisonsPage />} />
              <Route path="/guides" element={<GuidesPage />} />
              <Route path="/guides/:slug" element={<GuideDetailPage />} />
              <Route path="/bonus-rules" element={<BonusRulesPage />} />
              <Route path="/bonus-rules/:slug" element={<BonusRuleDetailPage />} />

              {/* Phase 8.1: SEO expansion routes */}
              <Route path="/compare/:pair" element={<ComparisonSEOPage />} />
              <Route path="/deneme-bonusu-veren-siteler" element={<HubPage />} />
              <Route path="/no-deposit-bonus-siteleri" element={<HubPage />} />
              <Route path="/free-spin-veren-siteler" element={<HubPage />} />
              <Route path="/:brand/deneme-bonusu" element={<BonusClusterPage />} />
              <Route path="/:brand/no-deposit" element={<BonusClusterPage />} />
              <Route path="/:brand/free-spins" element={<BonusClusterPage />} />

              {/* Admin */}
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
